import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getSelectedGrantValue } from '../../features/application/applicationJourneySlice';

const UnableToStartNewApplication = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const selectedGrantObject = useSelector(getSelectedGrantValue);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();
  const handleBtnClick = () => {
    history.push('/dashboardHub/dashboard');
  };
  const userGrantType = selectedGrantObject.user_grant_type.toLowerCase();

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s1',
          'You are not able to start a new application'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s2',
          'You have used all of your allowance for the current financial year.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s3',
          'The financial year runs from 6 April to 5 April the next year.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s4a',
          'As a '
        )}
        {userGrantType}
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s4b',
          ' of '
        )}
        {selectedGrantObject.grantTypeShort}
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s4',
          ', you can apply for up to '
        )}
        {selectedGrantObject.quota}
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s5',
          ' chargepoint sockets per financial year.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s6',
          'You can start a new application at the start of the next financial year.'
        )}
      </p>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordApp.UnableToStartNewApplication.s7',
          'Back to dashboard'
        )}
      </Button>
    </>
  );
};

export default UnableToStartNewApplication;
